var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.hasConditions)?_c('div',[(_vm.description)?_c('div',[_vm._v(_vm._s(_vm.$t('flowTemplate.forms.bo.edit'))+": "+_vm._s(_vm.description))]):_vm._e()]):_c('span',[_c('el-alert',{attrs:{"type":"warning","closable":false}},[_vm._v(_vm._s(_vm.$t('flowTemplate.config.missing')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }